/**
 * TanStack Query hooks for `day-wise-invoice-grouping`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dayWiseInvoiceGroupingQueryKeys,
	type CreateDayWiseInvoiceGroupingBody,
	type ListDayWiseInvoiceGroupingResponse,
	type DayWiseInvoiceGroupingRow,
} from "./api";

export function useDayWiseInvoiceGroupingList(): UseQueryResult<ListDayWiseInvoiceGroupingResponse, Error> {
	return useQuery({
		queryKey: dayWiseInvoiceGroupingQueryKeys.list(),
		queryFn: list,
	});
}

export function useDayWiseInvoiceGroupingCreate(): UseMutationResult<DayWiseInvoiceGroupingRow, Error, CreateDayWiseInvoiceGroupingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dayWiseInvoiceGroupingQueryKeys.all });
		},
	});
}

export function useDayWiseInvoiceGroupingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dayWiseInvoiceGroupingQueryKeys.all });
		},
	});
}
